module.exports = __webpack_public_path__ + "img/next_active.c43f0d39.png";